import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled container component for pause ad event titles.
 * Displays channel title and event title in a vertical layout.
 */
const PauseAdEventTitlesContainer = styled.div`
  width: ${520 * Screen.widthRatio}px;
  height: ${88 * Screen.widthRatio}px;
  display: flex;
  flex-direction: column;
  margin-left: ${20 * Screen.widthRatio}px;
`;

export default PauseAdEventTitlesContainer;
